export default __webpack_public_path__ + "static/media/payment_system.a6aa4ae6.png";